import { render, staticRenderFns } from "./rc-base-input.vue?vue&type=template&id=ec129b56&scoped=true&"
import script from "./rc-base-input.vue?vue&type=script&lang=js&"
export * from "./rc-base-input.vue?vue&type=script&lang=js&"
import style0 from "./rc-base-input.vue?vue&type=style&index=0&id=ec129b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec129b56",
  null
  
)

export default component.exports